import axios from "axios";
import { BASE_URL, SUB_URL, SUB_URL_GSM } from "./BaseUrl";

const ManageBinService ={

    add_bin: async (formValues) => {
        console.log(formValues);
        
        try {
          const formData = new FormData();

          formData.append("bin_name", formValues.bin_name);
          formData.append("bin_capacity", formValues.bin_capacity);
          formData.append("bin_status", formValues.bin_status);
          formData.append("bin_added_by", formValues.bin_added_by);
      
          const response = await axios.post(
            `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.add_bin}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              }
            }
          );
      
          console.log("Response Data:", response.data);
          return response.data;
        } catch (error) {
          console.error("Error adding bin:", error);
          return [];
        }
      },
      
    getBinData : async()=>{
      const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_bins}`);
      return response.data;
    },

    getGSMBinData : async()=>{
      const response = await axios.get(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_GSM.getGSMBin}`);
      return response.data;
    },

    // https://eknits-unit36.in/index.php/Apiv4/get_gsm_bins getGSMBin
};

export default ManageBinService;